import React, { forwardRef, useMemo } from 'react';

import { Form, IFormImperativeHandleProps } from '../form';
import { LensesExperienceFormProps } from './lenses-experience-form.models';
import { experience } from '../../../constants/profile';
import { RadioGroup } from '../form/radio-group';
import { Button } from '../button-new';
import { FormattedMessage } from 'react-intl';

export const LensesExperienceForm = forwardRef<
IFormImperativeHandleProps, LensesExperienceFormProps>(({
  onSubmit,
  validationSchema,
  defaultValues,
  isAction,
  isDisabled,
  getValue,
  options,
  customCheckedIcon,
  customUncheckedIcon,
  selectedClassName,
}, ref): JSX.Element => {
  const lensesExperienceOptions = useMemo(() => options || experience, [options]);

  const resultDefaultValues = useMemo(() => defaultValues || {
    clExperience: '',
  }, [defaultValues]);

  return (
    <Form
      ref={ref}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      defaultValues={resultDefaultValues}
    >
      <RadioGroup
        name="clExperience"
        options={lensesExperienceOptions}
        getValue={getValue}
        customCheckedIcon={customCheckedIcon}
        customUncheckedIcon={customUncheckedIcon}
        selectedClassName={selectedClassName}
      />
      {isAction && (
        <Button
          type="submit"
          style="dark"
          testId="save-experience"
          disabled={isDisabled}
        >
          <FormattedMessage id="common.save" />
        </Button>
      )}
    </Form>
  );
});
